import React from "react";
import "./Apropos.css";

const Apropos = () => {
  return (
    <div className="apropos">

      {/* ---- SECTION HEADER ---- */}
      <section className="apropos-header">
        <h1>À propos de Alwalid</h1>
        <p>
          Entreprise sénégalaise visionnaire, polyvalente et innovante,
          dédiée à la transformation digitale et au développement économique de l’Afrique.
        </p>

        {/* === BOUTON TÉLÉCHARGER PDF === */}
        <a
          href="/docs/Alwalid-Presentation.pdf"
          download="Alwalid-Presentation.pdf"
          className="download-btn"
        >
          📄 Télécharger la Présentation
        </a>
      </section>

      {/* ---- VISION & MISSION ---- */}
      <section className="vision-mission">
        <div className="card">
          <h2>Notre Vision</h2>
          <p>
            Faire de la transformation digitale le catalyseur du développement.
            Positionner l’Afrique comme un acteur fort, créatif et souverain
            dans l’économie mondiale.
          </p>
        </div>

        <div className="card">
          <h2>Notre Mission</h2>
          <p>
            Accompagner particuliers, entreprises et institutions dans leur
            croissance grâce à des solutions modernes, fiables et adaptées
            aux réalités africaines.
          </p>
        </div>
      </section>

      {/* ---- CHOISIR ---- */}
      <section className="choose-us">
        <h2>Pourquoi choisir Alwalid ?</h2>
        <ul>
          <li>✔ Fiabilité</li>
          <li>✔ Innovation</li>
          <li>✔ Accessibilité</li>
          <li>✔ Impact</li>
        </ul>
      </section>

      {/* ---- SERVICES ---- */}
      <section className="services">
        <h2>Nos Services</h2>

        <div className="services-grid">
          <div className="service-card">
            <h3>Vente de Produits Électroniques</h3>
            <p>
              Smartphones, ordinateurs, montres, accessoires… Apple, Samsung, Lenovo, HP, JBL…
            </p>
          </div>

          <div className="service-card">
            <h3>Change de Devises</h3>
            <p>CFA, USD, EUR… service rapide, sécurisé et transparent.</p>
          </div>

          <div className="service-card">
            <h3>Import / Export</h3>
            <p>
              Import US & international : produits tech, pièces détachées, accessoires…
            </p>
          </div>

          <div className="service-card">
            <h3>Impression 3D & Cartes NFC</h3>
            <p>Fabrication, personnalisation, design moderne.</p>
          </div>

          <div className="service-card">
            <h3>Branding & Création Digitale</h3>
            <p>Identité visuelle, photographie, contenu digital.</p>
          </div>

          <div className="service-card">
            <h3>Transformation Digitale</h3>
            <p>Modernisation d’entreprises pour un futur connecté.</p>
          </div>
        </div>
      </section>

      {/* ---- CONTACT ---- */}
      <section className="apropos-contact">
        <h2>Nous Contacter</h2>
        <p><strong>Adresse :</strong> Cité Onomo, Route de l’Aéroport Lot N° 107 – Dakar</p>
        <p><strong>Téléphone :</strong> +221 77 413 48 48 — Fixe : +221 33 858 89 22</p>
        <p><strong>International :</strong> +1 (614) 218-5351</p>
        <p><strong>Email :</strong> contact@alwaleed.sn</p>
      </section>

    </div>
  );
};

export default Apropos;
